//import Image from "next/image";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import Layout from "@/components/Layout";
import PerformanceOptimizer from "@/components/PerformanceOptimizer";
import { productList } from "@/data/productList";
import "../styles/hero-banner.css";

// Hero Banner Media Array - Optimized with fallbacks
const heroMedia: Array<{
  id: number;
  type: "image" | "video";
  src: string;
  fallback: string;
  alt: string;
  poster?: string; // For video thumbnails
}> = [
    {
      id: 1,
      type: "video",
      src: "/images/banner/Banner001.png",
      fallback: "https://via.placeholder.com/1920x1080/374151/ffffff?text=R.L+MINERALS+MINING",
      alt: "R.L Minerals Mining - Premium Industrial Minerals"
    },
    //  {
    //   id: 2,
    //   type: "video",
    //   src: "OyVfJtrtOr0",
    //   fallback: "/images/MINING.jpg", // Use actual image as fallback instead of placeholder
    //   alt: "R.L Minerals Mining Video",
    //   poster: "/images/MINING.jpg"
    // }
  ];

// Use first 6 products for homepage display
const products = productList.slice(0, 6);

const highlights = [
  {
    number: "01",
    title: "Quality Materials",
    description:
      "Premium grade minerals sourced and processed to international standards",
    icon: "/icons/quality.png",
  },
  {
    number: "02",
    title: "Expert Team",
    description: "Experienced professionals with decades of industry expertise",
    icon: "/icons/team.png",
  },
  {
    number: "03",
    title: "Timely Delivery",
    description: "Reliable logistics and on-time delivery to all destinations",
    icon: "/icons/truck.png",
  },
  {
    number: "04",
    title: "24/7 Support",
    description: "Round-the-clock customer support and technical assistance",
    icon: "/icons/support.png",
  },
];


const features = [
  {
    icon: "✅",
    title: "Premium Quality",
    desc: "All minerals undergo rigorous testing to meet international standards.",
  },
  {
    icon: "🚚",
    title: "Reliable Supply Chain",
    desc: "Strategic distribution ensures timely delivery across all regions.",
  },
  {
    icon: "💰",
    title: "Competitive Pricing",
    desc: "Best market rates without compromising on quality or service.",
  },
  {
    icon: "👩‍🔧",
    title: "Expert Support",
    desc: "Dedicated technical team to assist with custom requirements.",
  },
  {
    icon: "🧪",
    title: "Advanced Laboratory Testing",
    desc: "State-of-the-art lab facilities ensure precise mineral composition analysis and quality verification.",
  },
  {
    icon: "⛏️",
    title: "Efficient Mining Operations",
    desc: "Modern and sustainable mining techniques to extract minerals responsibly with minimal environmental impact.",
  },
];

export default function Index() {
  const [currentSlide, setCurrentSlide] = useState(0);
  // const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  // const [hasAnimated, setHasAnimated] = useState(false);

  // Smart preloading - load first image immediately, others progressively
  const [imagesLoaded, setImagesLoaded] = useState<Set<string>>(new Set());
  const [allImagesReady, setAllImagesReady] = useState(true);

  // useEffect(() => {
  //   if (!isAutoPlaying) return;

  //   const interval = setInterval(() => {
  //     setCurrentSlide((prev) => (prev + 1) % heroMedia.length);
  //   }, 5000); // Change slide every 5 seconds

  //   return () => clearInterval(interval);
  // }, [isAutoPlaying]);

  // Set animation flag after initial load
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setHasAnimated(true);
  //   }, 2000); // After all animations complete
  //   return () => clearTimeout(timer);
  // }, []);

  // const [slideDirection, setSlideDirection] = useState<'left' | 'right'>('right');
  // const [isTransitioning, setIsTransitioning] = useState(false);

  // const nextSlide = () => {
  //   if (isTransitioning) return;
  //   setSlideDirection('right');
  //   setIsTransitioning(true);
  //   setCurrentSlide((prev) => (prev + 1) % heroMedia.length);
  //   setTimeout(() => setIsTransitioning(false), 400);
  // };

  // const prevSlide = () => {
  //   if (isTransitioning) return;
  //   setSlideDirection('left');
  //   setIsTransitioning(true);
  //   setCurrentSlide((prev) => (prev - 1 + heroMedia.length) % heroMedia.length);
  //   setTimeout(() => setIsTransitioning(false), 400);
  // };

  // const goToSlide = (index: number) => {
  //   if (isTransitioning || index === currentSlide) return;
  //   setSlideDirection(index > currentSlide ? 'right' : 'left');
  //   setIsTransitioning(true);
  //   setCurrentSlide(index);
  //   setTimeout(() => setIsTransitioning(false), 400);
  // };

  // Smart preloading - prioritize first image, then load others progressively
  // useEffect(() => {
  //   const preloadImages = async () => {
  //     // First, load the initial image immediately
  //     const firstImage = heroMedia[0];
  //     if (firstImage.type === "image") {
  //       const img = new Image();
  //       img.onload = () => {
  //         setImagesLoaded(prev => new Set([...prev, firstImage.src]));
  //         setAllImagesReady(true); // Allow autoplay to start
  //       };
  //       img.onerror = () => {
  //         setImagesLoaded(prev => new Set([...prev, firstImage.fallback]));
  //         setAllImagesReady(true);
  //       };
  //       img.src = firstImage.src;
  //     }

  //     // Then progressively load other images in the background
  //     setTimeout(() => {
  //       heroMedia.slice(1).forEach((media, index) => {
  //         if (media.type === "image") {
  //           setTimeout(() => {
  //             const img = new Image();
  //             img.onload = () => setImagesLoaded(prev => new Set([...prev, media.src]));
  //             img.onerror = () => setImagesLoaded(prev => new Set([...prev, media.fallback]));
  //             img.src = media.src;
  //           }, index * 500); // Stagger loading by 500ms
  //         }
  //       });
  //     }, 1000); // Start after 1 second
  //   };

  //   preloadImages();
  // }, []);

  // Additional preloading for immediate next/prev images
  // useEffect(() => {
  //   const preloadImage = (src: string) => {
  //     if (src && !imagesLoaded.has(src)) {
  //       const img = new Image();
  //       img.onload = () => setImagesLoaded(prev => new Set([...prev, src]));
  //       img.src = src;
  //     }
  //   };

  //   // Preload next image
  //   const nextIndex = (currentSlide + 1) % heroMedia.length;
  //   if (heroMedia[nextIndex].type === "image") {
  //     preloadImage(heroMedia[nextIndex].src);
  //   }

  //   // Preload previous image
  //   const prevIndex = (currentSlide - 1 + heroMedia.length) % heroMedia.length;
  //   if (heroMedia[prevIndex].type === "image") {
  //     preloadImage(heroMedia[prevIndex].src);
  //   }
  // }, [currentSlide, imagesLoaded]);

  return (
    <Layout>
      {/* Performance Optimization - Preload critical images */}
      {/* <PerformanceOptimizer
        criticalImages={[heroMedia[0].src]} // First hero image
        preloadImages={[
          "/images/banner/Banner001.png", // Welcome section image
          ...heroMedia.slice(1, 3).map(media => media.src) // Next 2 hero images
        ]}
      /> */}
      {/* Hero Banner Slider Section */}
      <section
        className="hero-banner relative h-[50vh] sm:h-[60vh] md:h-[70vh] min-h-[400px] sm:min-h-[450px] md:min-h-[500px] text-white overflow-hidden"

      >
        {/* Minimal Loading Indicator - Only for first image */}
        {!allImagesReady && (
          <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center z-40">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-accent mx-auto mb-2"></div>
              <p className="text-white text-sm font-medium">Loading...</p>
            </div>
          </div>
        )}
        {/* Continuous Sliding Container */}
        <div className="slide-container w-full h-full relative">
          <AnimatePresence initial={false}>
            <motion.div
              key={currentSlide}
              // initial={{
              //   x: slideDirection === 'right' ? '100%' : '-100%'
              // }}
              // animate={{
              //   x: 0
              // }}
              // exit={{
              //   x: slideDirection === 'right' ? '-100%' : '100%'
              // }}
              transition={{
                duration: 0.4,
                ease: [0.4, 0, 0.2, 1]
              }}
              className="slide-item absolute inset-0 w-full h-full"
            >
              {/* Background Image */}
              <div className="slide-background absolute inset-0">
                {heroMedia[currentSlide].type === "video" ?(
                  <div className="absolute inset-0 w-full h-full overflow-hidden">
                    <video autoPlay loop muted playsInline className="w-full h-full object-cover">
                      <source src="/vidoes/COVER PAGE.mp4" type="video/mp4" />
                    </video>
                    {/* <iframe width="100%" height="100%"
                      src={"https://www.youtube.com/embed/" + heroMedia[currentSlide].src + "?autoplay=1&mute=1&loop=1&playlist=" + heroMedia[currentSlide].src + "&controls=0&showinfo=0&modestbranding=1"}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      className="absolute left-w-[120vw] h-[120vh] -translate-x-1/2 -translate-y-1/2 object-cover scale-105 pointer-events-none"
                      allowFullScreen>
                    </iframe> */}

                    {/* Gradient overlay for text readability */}
                    <div className="absolute inset-0 bg-gradient-to-r via-black/50 to-black/30 z-10"></div>
                  </div>

                ): <></>}
                {/* (
                  <img
                    src={imagesLoaded.has(heroMedia[currentSlide].src)
                      ? heroMedia[currentSlide].src
                      : heroMedia[currentSlide].fallback}
                    alt={heroMedia[currentSlide].alt}
                    className={`w-full h-full object-cover ${currentSlide === 0 ? 'hero-image' : ''}`}
                    loading={currentSlide === 0 ? "eager" : "lazy"}
                    decoding="async"
                    fetchpriority={currentSlide === 0 ? "high" : "low"}
                    data-preloaded={imagesLoaded.has(heroMedia[currentSlide].src)}
                    style={{
                      display: 'block',
                      imageRendering: 'auto'
                    }}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = heroMedia[currentSlide].fallback;
                    }}
                  />
                ) */}
                {/* Enhanced gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
              </div>


            </motion.div>
          </AnimatePresence>
        </div>

        {/* Fixed Content Overlay - Does NOT move with images */}
        <div className="fixed-content-overlay absolute inset-0 z-20 flex items-center pointer-events-none">
          {/* Enhanced Background for Better Content Visibility */}
          <div className="absolute inset-0 bg-gradient-to-r"></div>

          <div className="container mx-auto px-4 sm:px-6 py-4 sm:py-8 md:py-12 lg:py-16 relative z-10 pointer-events-auto">
            <div className="max-w-4xl">
              {/* Company Name - Mobile Responsive */}
              <div className="company-name-section mb-2 sm:mb-4 md:mb-6">
                <div className="flex items-center mb-3 sm:mb-4">
                  {/* Accent Bar - Theme Accent Color */}
                  {/* <div className="accent-bar w-1.5 sm:w-2 md:w-3 h-12 sm:h-16 md:h-20 bg-accent mr-3 sm:mr-4 md:mr-6 rounded-full shadow-2xl relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-t from-white/20 to-transparent"></div>
                    <div className="absolute top-0 left-1/2 w-0.5 h-full bg-gradient-to-b from-white/40 to-transparent transform -translate-x-1/2"></div>
                  </div> */}

                  {/* Company Title - Mobile Responsive */}
                  {/* <div className="company-title-container">
                    <h1 className="company-title text-xl sm:text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-white tracking-wide leading-tight relative">
                      <span className="block text-shadow-enhanced relative">
                        R.L MINERALS
                      </span>
                      <span className="block text-sm sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl font-bold text-accent mt-0.5 sm:mt-1 md:mt-2 tracking-wide relative">
                        MINING
                        <div className="absolute -bottom-0.5 left-0 w-full h-0.5 md:h-1 bg-gradient-to-r from-accent to-transparent rounded-full"></div>
                      </span>
                    </h1>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Media Type Indicator */}
        {/* <div className="absolute top-4 right-4 z-30 bg-black/40 backdrop-blur-sm text-white px-3 py-1 rounded-full text-sm">
        
          {currentSlide + 1} / {heroMedia.length}
        </div> */}
      </section>

      {/* Welcome Section */}
      <section className="py-16 md:py-24 bg-white relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">

          {/* GRID → only split into 2 columns on large screens (desktop) */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

            {/* IMAGE SECTION */}
            <motion.div
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 50 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <div
                className="relative bg-white/70 backdrop-blur-xl border border-white/60 rounded-2xl overflow-hidden 
          shadow-[0_4px_16px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_24px_rgba(37,99,235,0.12)] 
          transition-all duration-500 group w-full"
              >
                {/* Glow effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50/40 to-transparent opacity-0 
          group-hover:opacity-100 blur-2xl transition-opacity duration-700"></div>

                {/* Image */}
                <div className="relative w-full h-56 sm:h-72 lg:h-96 overflow-hidden rounded-2xl border border-blue-100/40 shadow-inner">
                  <motion.img
                    src="/images/Report.png"
                    alt="R.L Minerals Mining Facility"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out"
                    loading="lazy"
                    decoding="async"
                    fetchpriority="low"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = "/placeholder.svg";
                    }}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.5, ease: 'easeOut' }}
                  />
                </div>
              </div>
            </motion.div>

            {/* TEXT SECTION unchanged (desktop design preserved) */}
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 50 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-primary mb-8 text-center lg:text-left relative inline-block">
                Welcome to R.L MINERALS MINING
                <span className="block mx-auto mt-3 w-40 h-[4px] bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 rounded-full shadow-[0_0_15px_rgba(37,99,235,0.5)]"></span>
              </h2>

              <p className="text-lg text-foreground/80 mb-6 leading-relaxed">
                With a commitment to excellence since 2010, R.L MINERALS MINING has
                become a trusted name in industrial minerals distribution. Our
                state-of-the-art manufacturing facilities and rigorous quality
                control ensure every product meets the highest international
                standards.
              </p>

              <p className="text-lg text-foreground/80 mb-8 leading-relaxed">
                We produce over 25000+ MT of minerals monthly, supplying industries
                across construction, ceramics, glass, chemicals, and more. Our
                efficient distribution network ensures timely delivery to every
                corner of the country.
              </p>

              <Link
                to="/about"
                className="inline-flex items-center gap-2 text-accent font-semibold hover:gap-3 transition-all"
              >
                Learn More About Us
                <ArrowRight size={20} />
              </Link>
            </motion.div>
          </div>
        </div>

        {/* Background soft shapes */}
        <div className="absolute top-0 right-0 w-72 h-72 bg-orange-100/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-orange-50/50 rounded-full blur-3xl"></div>
      </section>



      {/* Products Section */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-[#f9fbff] to-[#eef2ff] relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">

          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#1e3a8a] to-[#2563eb] inline-block relative pb-3">
              Our Products
            </h2>
            <div className="mx-auto w-28 h-[3px] bg-gradient-to-r from-[#2563eb] to-[#1e3a8a] rounded-full mt-2 shadow-[0_0_10px_rgba(37,99,235,0.4)]"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto mt-4">
              Explore our range of industrial minerals designed for precision, consistency, and purity.
            </p>
          </div>

          {/* Product Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <motion.div
                key={product.id}
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 50 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                viewport={{ once: true, amount: 0.3 }}
              >
                <Link
                  to={product.path}
                  className="group relative bg-white/70 backdrop-blur-xl border border-white/60 rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.06)] 
              hover:shadow-[0_8px_24px_rgba(37,99,235,0.12)] hover:-translate-y-2 transition-all duration-300 block h-full overflow-hidden"
                >
                  {/* Decorative light accent */}
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 to-transparent opacity-0 group-hover:opacity-100 blur-2xl transition-opacity duration-500"></div>

                  {/* Product Image */}
                  <div className="relative w-full h-48 mb-6 rounded-xl overflow-hidden border border-blue-100/40 shadow-inner">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                      decoding="async"
                      fetchpriority="low"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = "/placeholder.svg";
                      }}
                    />
                  </div>

                  {/* Product Info */}
                  <div className="relative">
                    <h3 className="font-semibold text-lg text-[#1e3a8a] mb-3 group-hover:text-[#2563eb] transition-colors">
                      {product.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                      {product.description.substring(0, 100)}...
                    </p>

                    {/* Applications */}
                    <div className="flex flex-wrap gap-2 mb-5">
                      {product.applications.slice(0, 2).map((app, idx) => (
                        <span
                          key={idx}
                          className="text-xs font-medium bg-accent/10 text-accent px-2.5 py-1 rounded-md 
                      border border-blue-100 group-hover:bg-accent/5 transition-colors"
                        >
                          {app}
                        </span>
                      ))}
                    </div>

                    {/* View Details */}
                    <div className="flex items-center text-accent text-sm font-semibold group-hover:gap-2 transition-all">
                      View Details
                      <ArrowRight
                        size={16}
                        className="ml-1 group-hover:translate-x-1 transition-transform"
                      />
                    </div>
                  </div>

                  {/* Accent line */}
                  <span className="absolute left-0 bottom-0 w-0 h-[3px] bg-gradient-to-r from-[#1e3a8a] to-[#2563eb] transition-all duration-300 group-hover:w-full"></span>
                </Link>
              </motion.div>
            ))}
          </div>

          {/* View All Button */}
          <div className="text-center mt-14">
            <Link
              to="/products"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-[#1e3a8a] to-[#2563eb] text-white px-8 py-3 rounded-lg font-semibold shadow-md hover:shadow-lg hover:opacity-95 transition-all"
            >
              View All Products
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>

        {/* Soft gradient blobs */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-100/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-indigo-100/40 rounded-full blur-3xl"></div>
      </section>


      {/* Why Buy From Us Section */}

      {/* Why Buy From Us */}
      <section className="py-16 bg-gradient-to-b from-white via-blue-50/20 to-white relative overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 relative z-10">
          {/* Title */}
          <div className="text-center mb-10">
            <h2 className="text-4xl font-bold text-gray-900 inline-block relative pb-3">
              Why Buy From Us?
              <span className="absolute left-1/2 -bottom-1 w-32 h-1 bg-gradient-to-r from-blue-700 via-blue-800 to-blue-700 rounded-full -translate-x-1/2 shadow-[0_0_15px_rgba(11,29,182,0.5)]"></span>
            </h2>
          </div>

          {/* Description */}
          <div className="relative bg-white rounded-3xl shadow-[0_10px_30px_rgba(11,29,182,0.1)] border border-blue-100 p-10 mb-14 text-center overflow-hidden">
            <p className="text-lg leading-relaxed text-gray-700 max-w-4xl mx-auto">
              We operate <span className="font-semibold text-blue-700">15 large manufacturing units</span> with a production capacity of <span className="font-semibold text-blue-700">15,000 M.T of minerals</span> in a single order. Every product undergoes <span className="font-semibold text-blue-700">rigorous quality inspection</span> at each stage of processing, supported by our <span className="font-semibold text-blue-700">state-of-the-art in-house laboratories</span> where all production batches are thoroughly tested. Our advanced facilities ensure consistent and continuous product quality. In addition, a well-equipped production house and a strong <span className="font-semibold text-blue-700">distribution network across India</span> enable us to <span className="font-semibold text-blue-700">deliver every order on time</span>, every time.
            </p>
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-blue-700 via-blue-800 to-blue-700 rounded-full shadow-[0_0_20px_rgba(11,29,182,0.5)]"></div>
          </div>

          {/* Features Grid */}
          <div className="grid sm:grid-cols-2 gap-8">
            {features.map((f, i) => (
              <div
                key={i}
                className="relative bg-white border border-blue-100 rounded-[2rem] shadow-[0_10px_25px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(11,29,182,0.25)] p-8 transition-all duration-300 hover:-translate-y-2 overflow-hidden group"
              >
                <div className="absolute bottom-0 left-0 w-full h-1.5 bg-gradient-to-r from-blue-700 to-blue-800 rounded-b-[2rem] transition-all duration-300 group-hover:h-2"></div>
                <div className="flex items-start space-x-4">
                  <div className="text-4xl text-blue-700">{f.icon}</div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-1">{f.title}</h3>
                    <p className="text-gray-600">{f.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Background Blur Elements */}
        <div className="absolute -top-10 -right-20 w-72 h-72 bg-blue-100/40 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-50/50 rounded-full blur-2xl"></div>
      </section>
      <section className="py-20 bg-gradient-to-b from-white to-muted/40 relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">

          {/* Header */}
          <div className="text-center mb-14">
            <h2 className="text-4xl font-extrabold text-primary inline-block relative pb-3">
              Our Quality Promise
              <span className="absolute left-1/2 -bottom-1 w-32 h-1 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 rounded-full -translate-x-1/2 shadow-[0_0_15px_rgba(37,99,235,0.4)]"></span>
            </h2>
            <p className="text-foreground/70 text-lg mt-4">
              Excellence in every aspect of our operations
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-10">
            {highlights.map((highlight) => (
              <div
                key={highlight.number}
                className="group relative bg-gradient-to-b from-blue-50 to-white rounded-2xl shadow-md p-6 text-center 
          transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:bg-gradient-to-t 
          hover:from-white hover:to-blue-50 border border-blue-100 overflow-hidden"
              >
                {/* Blue Accent Line (INSIDE the card) */}
                <div className="absolute bottom-0 left-0 w-full h-[5px] bg-gradient-to-r from-blue-500 to-blue-700 rounded-b-2xl opacity-0 group-hover:opacity-100 transition-all duration-500"></div>

                {/* Icon */}
                <div className="flex justify-center mb-4">
                  <div className="bg-blue-100 p-4 rounded-full transition-transform duration-300 group-hover:scale-110">
                    <img
                      src={highlight.icon}
                      alt={highlight.title}
                      className="w-10 h-10 object-contain"
                      loading="lazy"
                      decoding="async"
                      fetchpriority="low"
                    />
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {highlight.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed">
                  {highlight.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Subtle background shapes */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-100/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-blue-50/50 rounded-full blur-3xl"></div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-24 bg-gradient-to-b from-white via-blue-50 to-blue-100 text-center relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
            Ready to Get Started?
          </h2>
          <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            Contact us today for a free quote and discover how we can meet your
            mineral supply needs
          </p>

          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-lg font-semibold
      bg-gradient-to-r from-accent/100 to-accent/90 text-white
      shadow-[0_4px_20px_rgba(37,99,235,0.4)]
      hover:shadow-[0_6px_25px_rgba(37,99,235,0.6)]
      hover:translate-y-[-2px] transition-all duration-300"
          >
            Get Your Quote Now
            <ArrowRight size={20} />
          </Link>
        </div>

        {/* Soft background accent */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[80%] h-40 bg-blue-100/40 blur-3xl rounded-full"></div>
      </section>

    </Layout>
  );
}
